/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Required_ErrorInputs */

const en_consent_required_error = /** @type {(inputs: Consent_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please accept the required terms to continue.`)
};

const de_consent_required_error = /** @type {(inputs: Consent_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte akzeptiere die erforderlichen Bedingungen, um fortzufahren.`)
};

const fr_consent_required_error = /** @type {(inputs: Consent_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez accepter les conditions requises pour continuer.`)
};

const es_consent_required_error = /** @type {(inputs: Consent_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, acepta los terminos requeridos para continuar.`)
};

const it_consent_required_error = /** @type {(inputs: Consent_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per favore, accetta i termini richiesti per continuare.`)
};

const nl_consent_required_error = /** @type {(inputs: Consent_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepteer de vereiste voorwaarden om door te gaan.`)
};

const pl_consent_required_error = /** @type {(inputs: Consent_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prosze zaakceptowac wymagane warunki, aby kontynuowac.`)
};

const fi_consent_required_error = /** @type {(inputs: Consent_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyvaksy vaaditut ehdot jatkaaksesi.`)
};

const da_consent_required_error = /** @type {(inputs: Consent_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter venligst de paakraevede vilkaar for at fortsaette.`)
};

const sv_consent_required_error = /** @type {(inputs: Consent_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Var vanlig acceptera de obligatoriska villkoren for att fortsatta.`)
};

/**
* | output |
* | --- |
* | "Please accept the required terms to continue." |
*
* @param {Consent_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_required_error = /** @type {((inputs?: Consent_Required_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Required_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_required_error(inputs)
	if (locale === "fr") return fr_consent_required_error(inputs)
	if (locale === "es") return es_consent_required_error(inputs)
	if (locale === "it") return it_consent_required_error(inputs)
	if (locale === "nl") return nl_consent_required_error(inputs)
	if (locale === "pl") return pl_consent_required_error(inputs)
	if (locale === "fi") return fi_consent_required_error(inputs)
	if (locale === "da") return da_consent_required_error(inputs)
	if (locale === "sv") return sv_consent_required_error(inputs)
	return en_consent_required_error(inputs)
});